import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export function getRules() {
   const { t } = useI18n();

   return yup.object({
      slides: yup.array().of(
         yup.object({
            image_id: yup.number().required(t('live-editor.content-blocks.errors.required')),
         }),
      ),
   });
}
